import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-base",
  templateUrl: "./base.component.html",
  styleUrls: ["./base.component.scss"],
})
export class BaseComponent implements OnInit {
  constructor(public router: Router, public activatedRoute: ActivatedRoute) {
    // console.log("BaseComponent constructor");
  }

  siteUpdateDate: Date | undefined;

  ngOnInit(): void {
    const data = this.activatedRoute.snapshot.data["data"];
    // const data =this.activatedRoute.snapshot.data["projectData"];
    console.log("environment", environment.stage);

    if (Array.from(data["projects"]).length > 0) {
      for (let index = 0; index < Array.from(data["projects"]).length; index++) {
        if (data["projects"][index]["Updated Date"] !== "") {
          this.siteUpdateDate = new Date(Date.UTC(0, 0, data["projects"][index]["Updated Date"]));

          if (this.siteUpdateDate.toString() == "Invalid Date") {
            this.siteUpdateDate = new Date(data["projects"][index]["Updated Date"]);
          }

          // console.log("Date", this.siteUpdateDate);
          break;
        }
      }
    }
    // console.log("BaseComponent");
    // console.log("data", new Date(Date.UTC(0, 0, data["projects"][0]["Updated Date"])));
  }
}
